import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TestPageComponent } from './test-page/test-page.component'

const routes: Routes = [
	{ path: 'test-page', component: TestPageComponent, }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TestRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/test/test-routing.module.ts